module.exports = __webpack_public_path__ + "media/images/footer/illu-mobile-3a3e0e7c826de7bafb2db7dce4c39e2b.svg";